import { MdCheck } from "react-icons/md";

import { Box, RadioGroup, Stack } from "@chakra-ui/react";
import { rem } from "polished";

import { Tag } from "../tag/tag";

import { TagOptionType as SelectOptionType } from "./types";

type TagOptionProps<T extends string> = SelectOptionType<T> & {
  name: string;
  onChangeValue: (value: boolean) => void;
  checked?: boolean;
};

export const TagOption = <T extends string>({
  name,
  value,
  color,
  label,
  disabled,
  checked,
}: TagOptionProps<T>) => {
  return (
    <Box _hover={{ backgroundColor: "gray.100" }} borderRadius="md">
      <RadioGroup.Item
        w="100%"
        id={`${name}_${value}`}
        px={4}
        py={2}
        value={value}
        disabled={disabled}
      >
        <RadioGroup.ItemHiddenInput />
        <Stack
          w="100%"
          opacity={disabled ? 0.5 : 1}
          direction="row"
          align="center"
          justify="space-between"
        >
          <Tag label={label} colorPalette={disabled ? "grey" : color} />
          {checked && <MdCheck size={rem(18)} />}
        </Stack>
      </RadioGroup.Item>
    </Box>
  );
};
